import title from "../media/images/cratelifterT.png";
import image2 from "../media/images/Lifter.jpg";
import "./CrateLifter.css"
const CrateLifter = () => {
    return (  
        <div className="CrateLifter">
        <div className="lifterPage">
            <div className="liferTitle">
                <img src={title} alt="d"/>
            </div>
            <div className="liferText">
                 <div className="blockText">
                    <div className="lifterBig">
                        <p>BEST POSITIONING SOLUTION</p>
                        <p>CRATE LIFTER</p>     
                    </div>
                    <div className="liferSmall">
                        <p>
                        The electric crate lifter allows the ergonomic positioning of the various containers at the workplace in an automatic or manual way. Thanks to these devices it is possible to optimize production times achieving considerable ergonomic and economic advantages.<br/>

                        If 40% of workers suffer from back and/or neck pain, lifters are a must from a health and safety point of view.<br/>

                        Our lifter can be customized to fit any type of production line and multiple vertical handling needs.<br/>

                        If You are looking for a quality KLT LIFTER,<br/>
                        Feel free to contact us<br/>
                        </p>
                    </div>
                </div>
                <div className="lifterBlockImage">
                    <img src={image2} alt=""/>
                </div>
            </div>
            <div className="lifterBlockImagePhone">
                    <img src={image2} alt=""/>
            </div>
            <div className="LiferCBlockK">
                <p>©Ecomode Studio 2025 - All Rights reserved</p>
            </div>
        </div>
        </div>
    );
}
 
export default CrateLifter;